export const STATIC_ROUTES_PATH_LAYER_ID = "route-line-layer-static";
export const INACTIVE_ROUTE_COLOR = "#dcdcdc";
export const ROUTE_DOT_SIZE_PX = 6;
export const DEFAULT_ROUTE_DOT_GAP = 0;
